import { render, staticRenderFns } from "./TrainChangePerson.vue?vue&type=template&id=641cbbb6&scoped=true&"
import script from "./TrainChangePerson.vue?vue&type=script&lang=js&"
export * from "./TrainChangePerson.vue?vue&type=script&lang=js&"
import style0 from "./TrainChangePerson.vue?vue&type=style&index=0&id=641cbbb6&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "641cbbb6",
  null
  
)

export default component.exports